import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useMinorTestCongratsStyles = makeStyles(() => ({
  page: {
    width: '100%',
    minHeight: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.background,
    boxSizing: 'border-box',
    padding: `${spacing.md}px ${spacing.sm}px ${spacing.xl}px`,
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: `40px 80px ${spacing.xl}px`,
    },
  },
  loadingPage: {
    width: '100%',
    minHeight: 'calc(100vh - 64px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.background,
  },
  contentContainer: {
    width: '100%',
    maxWidth: 804,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: spacing.lg,
    paddingTop: spacing.lg,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      paddingTop: spacing.sm,
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    padding: 40,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    boxSizing: 'border-box',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: spacing.md,
      backgroundColor: 'transparent',
    },
  },
  title: {
    margin: 0,
    color: colors.primary,
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.xxl,
    lineHeight: 1.4,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.lg,
      lineHeight: 1.3,
    },
  },
  description: {
    color: colors.textBody,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    lineHeight: 1.4,
    '& p, & h3': {
      margin: 0,
    },
    '& *': {
      fontFamily: `${fonts.opensans} !important`,
      background: 'transparent !important',
    },
    '& a': {
      color: `${colors.primaryDark} !important`,
    },
    '& li': {
      textAlign: 'left',
    },
  },
  ctaButton: {
    ...primaryButtonStyle,
    width: '100%',
    textTransform: 'none',
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    padding: spacing.sm,
    backgroundColor: colors.white,
    zIndex: 10,
    boxSizing: 'border-box',
  },
}));
